import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';

const TeamSectionContainer = styled.section`
  padding: 80px 0;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
`;

const TeamMember = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const MemberImage = styled.div`
  overflow: hidden;
  
  img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    transition: ${props => props.theme.transitions.main};
    
    ${TeamMember}:hover & {
      transform: scale(1.1);
    }
  }
`;

const MemberInfo = styled.div`
  padding: 20px;
  text-align: center;
`;

const MemberName = styled.h3`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: 5px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const MemberPosition = styled.p`
  color: ${props => props.theme.colors.primaryColor};
  font-weight: ${props => props.theme.fontWeights.medium};
  margin-bottom: 15px;
`;

const MemberBio = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.7;
`;

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Faculty Name',
      position: 'Structural Design Expert',
      bio: 'Brief bio about the faculty member\'s background, expertise, and teaching philosophy.',
      image: '/placeholder/300/300'
    },
    {
      name: 'Faculty Name',
      position: 'Civil Engineering Specialist',
      bio: 'Brief bio about the faculty member\'s background, expertise, and teaching philosophy.',
      image: '/placeholder/300/300'
    },
    {
      name: 'Faculty Name',
      position: 'TNPSC Exam Coach',
      bio: 'Brief bio about the faculty member\'s background, expertise, and teaching philosophy.',
      image: '/placeholder/300/300'
    }
  ];

  return (
    <TeamSectionContainer>
      <div className="container">
        <SectionHeader 
          title="Our Team" 
          subtitle="Meet the experts who will guide you through your learning journey" 
        />
        
        <TeamGrid>
          {teamMembers.map((member, index) => (
            <TeamMember key={index}>
              <MemberImage>
                <img src={member.image} alt={member.name} />
              </MemberImage>
              <MemberInfo>
                <MemberName>{member.name}</MemberName>
                <MemberPosition>{member.position}</MemberPosition>
                <MemberBio>{member.bio}</MemberBio>
              </MemberInfo>
            </TeamMember>
          ))}
        </TeamGrid>
      </div>
    </TeamSectionContainer>
  );
};

export default TeamSection;
